import { DeputateIcon, ScenarioIllustration, TimetableIcon } from '@bp/ui-components';
import { observer } from 'mobx-react-lite';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { IconMenu } from '../../../components/IconMenu/IconMenu';
import { IconMenuItem } from '../../../components/IconMenuItem/IconMenuItem';
import { Page } from '../../../components/Page/Page';
import { usePermissionChecker } from '../../../hooks/usePermissionChecker';

export const DeputateEvaluatePage = observer(() => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const permissions = usePermissionChecker();

  return (
    <Page
      isForbidden={!permissions?.canReadDeputate()}
      title={`${t('deputate.title', { count: 2 })} ${t('deputate.evaluate.title').toLowerCase()}`}
    >
      <IconMenu hasMarginBottom>
        <IconMenuItem
          label={t('deputate.planTitle')}
          icon={<ScenarioIllustration />}
          bubbleType={5}
          onClick={() => navigate(t('routes.deputate.evaluate.planned.slug'))}
        />
      </IconMenu>
      <IconMenu headline={t('deputate.current')}>
        <IconMenuItem
          label={t('deputate.annual')}
          icon={<DeputateIcon />}
          bubbleType={6}
          onClick={() => navigate(t('routes.deputate.evaluate.annual.slug'))}
        />
        <IconMenuItem
          label={t('deputate.cutoffDate')}
          icon={<TimetableIcon />}
          bubbleType={7}
          onClick={() => navigate(t('routes.deputate.evaluate.cutoff.slug'))}
          disabled
        />
      </IconMenu>
    </Page>
  );
});
